module.exports = __webpack_public_path__ + "img/report.e8f3068f.png";